export class SubmitEvent {
    source: string | undefined;
    data: any;

    constructor(init?: Partial<SubmitEvent>) {
        Object.assign(this, init);
    }
}